module.exports = __webpack_public_path__ + "img/photo-example.315b7310.webp";